<!--
 * @Description: 护工用户配置新增和编辑所用的对话框组件
 * @Author: gaohc, fengal
 * @Date: 2021-04-01 09:09:02
 * @LastEditTime: 2023-11-27 14:51:53
-->

<template>
  <el-dialog width="640px" :title="dialogTitle" :visible.sync="visible" :close-on-click-modal="false" @open="initData"
    :before-close="handleCancel" center>
    <el-form class="form" ref="attendantForm" :model="attendantForm" :rules="rules"
      style="padding-left: 10px;" label-width="120px">
      <el-form-item v-if="title === '培训证书类型'" :label="title" prop="certText">
        <el-input size="small" clearable v-model.trim="attendantForm.certText" placeholder="请输入名称" maxlength="30" 
          autocomplete="off" style="width: 320px"></el-input>
      </el-form-item>
      <el-form-item v-if="title === '评价标签'" :label="title" prop="labelText">
        <el-input size="small" clearable v-model.trim="attendantForm.labelText" placeholder="请输入名称" maxlength="10" 
          autocomplete="off" style="width: 320px"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('attendantForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'AttendantCfgDialog',
  props: ['title', 'visible', 'operate', 'attendantDialogId'],
  data() {
    return {
      attendantForm: {},
      rules: {
        certText: [{required: true, message: `请输入${this.title}`, trigger: 'blur'}],
        labelText: [{required: true, message: `请输入${this.title}`, trigger: 'blur'}],
      },
      urlGet: '',
      urlSave: '',
      urlUpdate: '',
      attributeName: '',
    }
  },

  computed: {
    dialogTitle() {
      return this.operate == 'add' ? `新增${this.title}` : `编辑${this.title}`
    },
  },

  methods: {
    initData() {
      this.clearVaild();
      if (this.operate == 'edit') {
        this.getUrl();
        let params = {id: this.attendantDialogId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: this.urlGet,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.attendantForm = result.data || {};
          }
        })
      }
    },

    clearData() {
      this.attendantForm = {};
    },

    clearVaild() {
      this.$nextTick(() => this.$refs['attendantForm'].clearValidate());
    },

    handleSubmit(attendantForm) {
      this.$refs[attendantForm].validate((valid) => {
        if (!valid) return false;
        this.getUrl();
        let url = this.operate == 'add' ? this.urlSave : this.urlUpdate;
        let method = this.operate == 'add' ? 'POST' : 'PUT';
        let header = this.encryptionUtil.signatureBody(this.attendantForm,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: this.attendantForm,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.clearData();
            this.$emit('close-attendant-dialog', this.title, true);
          }
        })
      })
    },

    handleCancel() {
      this.clearData();
      this.$emit('close-attendant-dialog', this.title, false);
    },

    getUrl() {
      switch (this.title) {
        case '培训证书类型':
          this.attributeName = 'certText';
          this.urlGet = Constant.URL_GET_TRAININGCERTCFG;
          this.urlSave = Constant.URL_SAVE_TRAININGCERTCFG;
          this.urlUpdate = Constant.URL_UPDATE_TRAININGCERTCFG;
          break

        case '评价标签':
          this.attributeName = 'labelText';
          this.urlGet = Constant.URL_GET_COMMENTLABELCFG;
          this.urlSave = Constant.URL_SAVE_COMMENTLABELCFG;
          this.urlUpdate = Constant.URL_UPDATE_COMMENTLABELCFG;
          break

        default:
          break
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/syscfg/components/usercfg/AttendantCfgDialog.vue